import { isValidElement, type ReactNode } from "react";

export const getNodeText = (node: ReactNode): string  => {
    if (typeof node === "string" || typeof node === "number") return String(node);
    if (Array.isArray(node)) return node.map(getNodeText).join(" ");
    if (isValidElement<{ children?: ReactNode }>(node)) return getNodeText(node.props.children);
    return "";
}
